import type { FrontendOnlyPieces } from '../../hooks/useSettings/WebsiteSettings';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { Icon } from '@iconify/react';
import cannabisIcon from '@iconify-icons/fa-solid/cannabis';
import leafIcon from '@iconify-icons/fa-solid/leaf';
import type { $TSFixMe } from '@calefy-inc/utilityTypes';

const tileIcons = (internalName: string) => {
  switch (internalName) {
    case 'retail_cannabis':
      return <AttachMoneyIcon color='inherit' fontSize='large' />;
    case 'microprocessing_cannabis_':
      return <Icon icon={leafIcon} width={'35px'} />;
    case 'cannabis_microcultivator_or_licensed_producer':
      return <Icon icon={cannabisIcon} width={'35px'} />;

    default:
      return <Icon icon={cannabisIcon} width={'35px'} />;
  }
};

const businessFilter = (business: $TSFixMe) => {
  const allowedBusinessNames = [
    'retail_cannabis',
    'microprocessing_cannabis_',
    'cannabis_microcultivator_or_licensed_producer',
  ];
  if (
    process.env.NODE_ENV !== 'production' ||
    window.location.origin === 'https://staging-calefy.fuseinsurance.ca'
  ) {
    allowedBusinessNames.push('testing_business');
  }
  return allowedBusinessNames.includes(business.internalName);
};

// Cannabis Insurance — frontend-only pieces; all data fields live on the backend
export const frontendPieces: FrontendOnlyPieces = {
  slug: 'cannabisinsurance',
  businessFilter,
  tileIcons,
};
